import React, { forwardRef } from 'react';
import Base, {
  TypographyProps as MUITypographyProps,
} from '@material-ui/core/Typography';

interface TypographyProps extends MUITypographyProps {
  component?: React.ElementType;
}

const Typography = forwardRef<HTMLElement, TypographyProps>((props, ref) => {
  return <Base {...props} ref={ref} />;
});

Typography.displayName = 'Typography';

export default Typography;
